import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import React from "react";
import { useGetPossibleLocationsQuery } from "../api/courses";
import { GlgSelect } from "../../shared/components";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../store/filtersSlice";

export const LocationFilter = () => {
  
  const dispatch = useDispatch()

  const {data: possibleLocations, isLoading} = useGetPossibleLocationsQuery()

  return(
  <>
    <div className="bold">{window.I18n.t('courses.course_fields.location')}</div>
    <GlgSelect
      searchable
      className='courses-filter-dropdown'
      items={possibleLocations || []}
      height={33}
      onChange={(location) => dispatch(setLocation(location))}
      defaultValue={useSelector((state) => state?.filters?.location)}>
    </GlgSelect>
  </>
  )
};